import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class DataService {
    cdnBaseUrl: string = null;
    domain: string = null;
}